import { render, staticRenderFns } from "./v-footer-contact.vue?vue&type=template&id=274372e2&scoped=true&"
import script from "./v-footer-contact.vue?vue&type=script&lang=js&"
export * from "./v-footer-contact.vue?vue&type=script&lang=js&"
import style0 from "./v-footer-contact.vue?vue&type=style&index=0&id=274372e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274372e2",
  null
  
)

export default component.exports